/*eslint-disable */
import { bus } from '@/main';
var $ = window.jQuery = require('jquery');
import { mapGetters } from 'vuex';
export default {
  name: 'user-list',
  components: {
  },
  props: [],
  data () {
    return {
      vistaConfState:false,
      vistaConfData:null,
      vistaConfDataResults:[]
    }
  },
  computed: {
    ...mapGetters([
      'vistaConferenceUserGetters',
    ]),
    getVistaConfInfo(){
      this.vistaConfData = this.$store.getters.vistaConferenceUserGetters.data;
      return
    },
    getVistaConfResults(){
      if(this.vistaConfData){
        this.vistaConfDataResults =  this.vistaConfData.results
      }
    }
  },
  mounted () {
    this.getVistaConfInfo
    this.getVistaConfResults
    bus.$on('vistaConfStateBus', (data) => {
      this.vistaConfState = data
    })
  },
  methods: {
    vistaConfCreatePopup(){
      this.vistaConfState = true
      $('body').addClass('body_right_scroll_remove')
    }
  },
  watch:{
    getVistaConfInfo(){
      return this.$store.getters.vistaConferenceUserGetters
    },
    getVistaConfResults(){
      if(this.vistaConfData){
        this.vistaConfDataResults =  this.vistaConfData.results
      }
      return
    }
  }
}